import React from 'react';
import { Button, Checkbox, CopyButton, SimpleGrid, Stack, Text } from '@mantine/core';
import { IconCheck, IconCopy } from '@tabler/icons-react';
import type { TypeAuthFlow } from '@/types/auth/types.auth.flow';

type Props = { flow: TypeAuthFlow; codes: string[] };

const FlowRecoveryCodes: React.FC<Props> = ({ flow, codes }) => {
    const [saved, setSaved] = React.useState(false);
    return (
        <Stack gap="md">
            <Text size="sm" c="dimmed">Questi codici ti fanno entrare se perdi il telefono con l’app. Ognuno vale una volta sola e non li rivedrai più: salvali in un posto sicuro.</Text>
            <SimpleGrid cols={2} spacing="xs" component="ul" style={{ listStyle: 'none', padding: 0, margin: 0 }} aria-label="Codici di recupero">
                {codes.map((code) => <Text key={code} component="li" ff="monospace" ta="center" fw={600}>{code}</Text>)}
            </SimpleGrid>
            <CopyButton value={codes.join('\n')}>
                {({ copied, copy }) => (
                    <Button variant="light" radius="md" fullWidth leftSection={copied ? <IconCheck size={18} /> : <IconCopy size={18} />} onClick={copy}>
                        {copied ? 'COPIATI' : 'COPIA I CODICI'}
                    </Button>
                )}
            </CopyButton>
            <Checkbox label="Li ho salvati in un posto sicuro" checked={saved} onChange={(event) => setSaved(event.currentTarget.checked)} />
            <Button radius="md" fullWidth disabled={!saved} onClick={flow.acknowledgeCodes}>CONTINUA</Button>
        </Stack>
    );
};

export default FlowRecoveryCodes;
